/**
 * 하단 탭 네비. SPEC §4, DESIGN.md "Tab bar (하단)" 참조.
 * 5칸 — 메인 / 통화 / SMS / TODO / 더보기. active = accent.
 */
import { NavLink } from 'react-router-dom';
import { cn } from '../lib/cn';

type Tab = {
  to: string;
  label: string;
  /** mono single-glyph (간이 아이콘 — 디자인 토큰 외 새 자산 도입 안 함) */
  glyph: string;
  end?: boolean;
};

const TABS: Tab[] = [
  { to: '/', label: '메인', glyph: '⌂', end: true },
  { to: '/calls', label: '통화', glyph: '☎' },
  { to: '/sms', label: 'SMS', glyph: '✉' },
  { to: '/todos', label: 'TODO', glyph: '✓' },
  { to: '/more', label: '더보기', glyph: '⋯' },
];

export function BottomTabs() {
  return (
    <nav
      aria-label="하단 메뉴"
      className="fixed bottom-0 left-0 right-0 z-40 bg-[var(--surface)]/95 backdrop-blur border-t border-[var(--border)] pb-[env(safe-area-inset-bottom)]"
    >
      <ul className="flex h-16 max-w-md mx-auto">
        {TABS.map((tab) => (
          <li key={tab.to} className="flex-1">
            <NavLink
              to={tab.to}
              end={tab.end}
              className={({ isActive }) =>
                cn(
                  'h-full w-full flex flex-col items-center justify-center gap-[2px] transition-colors',
                  isActive
                    ? 'text-[var(--accent)]'
                    : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)]',
                )
              }
            >
              <span aria-hidden className="text-[16px] leading-none">{tab.glyph}</span>
              <span className="text-[10px] font-medium tracking-wide leading-none">{tab.label}</span>
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
